import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";
import { addNewPayment } from "store/Payment/actions";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
} from "store/registration-admin/actions";
import { getcyclelist } from "store/cycle/actions";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAllLabs,
  updateAllLabs,
  approveUnapproveLab,
} from "store/registration-admin/actions";

import ApproveUnapproveModal from "components/Common/ApproveUnapproveModal";
import "assets/scss/table.scss";
import AllParticipantsEditparticipantsModal from "./All-participant-EditModal";
import AllParticipantPaymentModal from "./All-participant-PaymentModal";
import moment from "moment";
class PendingLabs extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.handleSchemeChange = this.handleSchemeChange.bind(this);
    this.handleSchemeModalOpen = this.handleSchemeModalOpen.bind(this);
    this.handleSchemeModalClose = this.handleSchemeModalClose.bind(this);

    this.state = {
      showModal: false,
      editModal: false,
      selectedParticipant: null,
      showPaymentModal: false,
      AllLabs: [],
      approvedLabs: [],
      selectedProvince: "",
      provinceOptions: [],
      selectedSchemeCount: "",
      ListCity: [],
      ListDistrict: [],
      showSchemeModal: false,
      selectedSchemes: [],
      ListProvince: [],
      ListDesignation: [],
      CycleList: [],
      selectedScheme: null,
      id: "",
      btnText: "Copy",
      isPaymentModalOpen: false,
      isMembershipModalOpen: false,
      organization_name: "",
      isApproved: false,
      unapprovedModal: false,
      tooltipContent: ["Worst", "Bad", "Average", "Good", "Excellent"],
      filteredLabs: [],
      cityOptions: [],
      districtOptions: [],
      pendingLabListColumns: [],
      selectedParticipantType: "All Participant",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      pendingLabListColumns: [
        {
          text: "id",
          dataField: "id",
          sort: true,
          hidden: true,
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          formatter: (cellContent, AllLabs) => <>{AllLabs.id}</>,
        },
        {
          dataField: "registered_at",
          text: "Joining Date",
          sort: true,
          headerStyle: {
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          formatter: (cellContent, row) => (
            <>
              {row.registered_at
                ? moment(row.registered_at).format("DD MMM YY")
                : "-"}
            </>
          ),
        },
        {
          dataField: "district",
          text: "District",
          sort: true,
          headerStyle: { textAlign: "center" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.district}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "city",
          text: "City",
          sort: true,
          headerStyle: { textAlign: "center" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.city}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "name",
          text: "Participant",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <Link
                  to="#"
                  onClick={e => this.openLabModal(e, row)}
                  style={{
                    cursor: "pointer",
                    color: isPart ? "#c20505ff" : "#007bff", // black if red row, else default blue
                  }}
                >
                  {row.name}
                </Link>
              </span>
            );
          },
        },
        {
          dataField: "lab_staff_name",
          text: "Name",
          sort: true,
          headerStyle: { textAlign: "center" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.lab_staff_name}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "landline_registered_by",
          text: "Contact No.",
          headerStyle: { textAlign: "center" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.landline_registered_by}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "schemes",
          text: "Scheme",
          sort: true, // ✅ Enable sorting
          headerStyle: { textAlign: "center", cursor: "pointer" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          formatter: (cellContent, lab) => {
            const count = Array.isArray(lab.schemes) ? lab.schemes.length : 0;
            return (
              <Link
                to="#"
                onClick={() => this.handleSchemeModalOpen(lab)}
                style={{ fontWeight: "bold", textDecoration: "underline" }}
              >
                {count > 0 ? `${count}` : "No schemes"}
              </Link>
            );
          },
          sortFunc: (a, b, order) => {
            const countA = Array.isArray(a) ? a.length : 0;
            const countB = Array.isArray(b) ? b.length : 0;
            if (order === "asc") {
              return countA - countB;
            }
            return countB - countA;
          },
          filter: textFilter({
            onFilter: (filterValue, data) => {
              const count = parseInt(filterValue, 10); // convert input to number
              if (isNaN(count)) return data; // if input is not a number, return all
              return data.filter(
                row =>
                  Array.isArray(row.schemes) && row.schemes.length === count
              );
            },
          }),
        },

        {
          dataField: "payment_settlement",
          text: "Payment Settlement",
          skipDefaultStyles: true,
          headerStyle: {
            backgroundColor: "#d0e2ff",
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }

            return { backgroundColor: "#d0e2ff", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, row) => {
            const settlement = (
              row.payment_settlement ??
              row.payment?.settlement ??
              ""
            )
              .toString()
              .trim();

            const remaining = row.remaining_amount ?? "-";

            // Format remaining amount with commas
            const formattedRemaining =
              remaining && !isNaN(remaining)
                ? Number(remaining).toLocaleString()
                : "–";

            const displayText = `${
              settlement && settlement !== "--" ? settlement : "–"
            }${
              settlement === "Part" ? ` (Remaining: ${formattedRemaining})` : ""
            }`;

            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  color: settlement === "Part" ? "#c20505ff" : "black",
                }}
                title={displayText} // <-- tooltip on hover
              >
                <span>
                  {settlement && settlement !== "--" ? settlement : "–"}
                </span>
                {settlement === "Part" && (
                  <span
                    style={{
                      fontSize: "0.85em",
                      color: "#c20505ff",
                    }}
                  >
                    {formattedRemaining}
                  </span>
                )}
              </div>
            );
          },
        },

        {
          dataField: "payment_status",
          text: "Payment Status",
          headerStyle: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for header
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.payment_status}
              </span>
            </>
          ),
          filter: textFilter(),
        },

        {
          dataField: "membership_status",
          text: "Membership",
          headerStyle: { textAlign: "center" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => {
            // Assuming the cycle status is stored in AllLabs.cycle_status or similar
            const cycleStatus = AllLabs.cycle_status || ""; // adjust if your key is different

            const displayStatus =
              cycleStatus.toLowerCase() === "active"
                ? "Active"
                : AllLabs.membership_status
                ? AllLabs.membership_status
                : "Inactive";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {displayStatus}
              </span>
            );
          },
          filter: textFilter(),
        },
        {
          dataField: "data",
          text: "id",
          isDummyField: true,
          editable: false,
          text: "Action",
          headerStyle: { textAlign: "center" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <Tooltip title="Update">
                  <Link
                    to={{
                      pathname: `/${this.state.organization_name}/editlabdata/${AllLabs.id}`,
                      state: { selectedParticipant: AllLabs },
                    }}
                  >
                    <i
                      className="mdi mdi-pencil font-size-18"
                      style={{ color: "#28a745" }}
                    ></i>
                  </Link>
                </Tooltip>

                {/* {/ Revert Status Button /} */}
                <Tooltip title="Membership Status">
                  <Link
                    className=""
                    to="#"
                    onClick={() => this.isMembershipModalOpen(AllLabs)} // Opens the Approved/Unapproved modal
                  >
                    <i className="mdi mdi-refresh font-size-14"></i>
                  </Link>
                </Tooltip>
                <Tooltip title="Payment">
                  <Link
                    to={{
                      pathname:
                        AllLabs.payment_settlement?.toString().toLowerCase() ===
                        "part"
                          ? `/${this.state.organization_name}/partialpayment2/${AllLabs.id}` // Partial
                          : `/${this.state.organization_name}/payment/${AllLabs.id}`, // Full
                      state: { selectedParticipant: AllLabs },
                    }}
                  >
                    <i className="fas fa-money-bill-wave"></i>
                  </Link>
                </Tooltip>
                <Tooltip title="History">
                  <Link
                    className="fas fa-comment font-size-18"
                    to={`/${this.state.organization_name}/Alllabs-History/${AllLabs.id}`}
                  />
                </Tooltip>
              </div>
            </>
          ),
        },
      ],
    };
    console.log(
      "Initialized user_id:",
      localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "No authUser found in localStorage"
    );
    this.toggle = this.toggle.bind(this);
    this.handleApprovedEvent = this.handleApprovedEvent.bind(this);
    this.togglePatientModal = this.togglePatientModal.bind(this);
    this.toggleMarketerModal = this.toggleMarketerModal.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleParticipantTypeChange =
      this.handleParticipantTypeChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  isPaymentModalOpen = participant => {
    this.setState(
      {
        isPaymentModalOpen: true,
        selectedParticipant: participant,
      },
      () => console.log("Modal State Updated:", this.state.selectedParticipant)
    );
  };

  isMembershipModalOpen = participant => {
    console.log("Opening Membership Modal for Participant:", participant); // Debug log
    this.setState(
      {
        isMembershipModalOpen: true,
        selectedParticipant: participant, // Store the correct participant
      },
      () =>
        console.log(
          "Membership Modal Opened for:",
          this.state.selectedParticipant
        )
    );
  };
  handleSchemeCountChange = e => {
    const selectedSchemeCount = e.target.value;
    this.setState({ selectedSchemeCount }, () => {
      this.applyFilters();
    });
  };

  getMaxSchemeCount = () => {
    const { AllLabs } = this.state;

    if (!Array.isArray(AllLabs)) return 0;

    let max = 0;
    AllLabs.forEach(lab => {
      const count = Array.isArray(lab.schemes) ? lab.schemes.length : 0;
      if (count > max) max = count;
    });

    return max;
  };

  handleParticipantTypeChange(event) {
    const selectedParticipantType = event.target.value;
    console.log("Selected Participant Type:", selectedParticipantType);

    this.setState({ selectedParticipantType }, () => {
      console.log(
        "Updated selectedParticipantType in state:",
        this.state.selectedParticipantType
      );
      this.applyFilters();
    });
  }

  handleSchemeChange = event => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
    const { organization_name } = this.state; // Extract from state
  };

  handleSchemeModalOpen(lab) {
    const uniqueSchemes = [
      ...new Map((lab.schemes || []).map(s => [s.scheme_name, s])).values(),
    ];

    this.setState({
      showSchemeModal: true,
      selectedSchemes: uniqueSchemes,
      selectedParticipant: lab,
    });
  }

  handleSchemeModalClose() {
    this.setState({
      showSchemeModal: false,
      selectedSchemes: [],
      selectedParticipant: null,
    });
  }

  applyFilters = () => {
    const {
      AllLabs,
      selectedParticipantType,
      selectedScheme,
      selectedCycle,
      organization_name,
    } = this.state;

    console.log("Filtering with:", {
      selectedParticipantType,
      selectedScheme,
      selectedCycle,
      AllLabs,
    });

    const filteredData = AllLabs.filter(lab => {
      const membershipStatus = lab.membership_status?.trim().toLowerCase();
      const membershipDetail = lab.membership_status_detail
        ? lab.membership_status_detail.trim().toLowerCase()
        : "";
      let matchesParticipantType = false;

      if (selectedParticipantType === "All Participant") {
        matchesParticipantType = true; // Show all participants
      } else if (selectedParticipantType === "Approved Participant") {
        matchesParticipantType =
          membershipStatus === "active" || membershipDetail === "active"; // Approved or Active participants
      } else if (selectedParticipantType === "Pending Participant") {
        matchesParticipantType = membershipStatus === "pending"; // Pending participants
      } else if (selectedParticipantType === "Unapproved Participant") {
        matchesParticipantType = membershipStatus === "inactive"; // Only participants with "inactive" membership status
      } else if (selectedParticipantType === "Suspended Participant") {
        matchesParticipantType = membershipStatus === "suspended"; // Suspended participants
      } else if (selectedParticipantType === "New Register") {
        matchesParticipantType = membershipStatus === "new register";
      }
      const matchesProvince =
        !this.state.selectedProvince ||
        lab.province?.toString().toLowerCase() ===
          this.state.selectedProvince.toLowerCase();

      // 🧠 Match selected scheme
      const matchesScheme =
        !selectedScheme ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            s =>
              String(s.scheme_id) === String(selectedScheme) ||
              String(s.scheme_name) === String(selectedScheme)
          ));

      // 🧩 Match selected cycle (only when selected)
      const matchesCycle =
        !selectedCycle ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            s => s.cycle_id?.toString() === selectedCycle.toString()
          ));

      // ✅ Return labs that match all filters
      // NEW FILTER — scheme count
      const matchesSchemeCount =
        !this.state.selectedSchemeCount ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.length === parseInt(this.state.selectedSchemeCount));

      return (
        matchesParticipantType &&
        matchesScheme &&
        matchesCycle &&
        matchesSchemeCount &&
        matchesProvince
      );
    });

    console.log("Filtered Data:", filteredData);

    // Special handling for "Pending Participant"
    if (selectedParticipantType === "Pending Participant") {
      this.props.history.push(`/${organization_name}/pending-participant`);
      return;
    }

    // Update the filtered list in the state for other participant types
    this.setState({ filteredLabs: filteredData }, () => {
      console.log("Updated filteredLabs:", this.state.filteredLabs);
    });
  };

  applyFiltersFromQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const filterType = queryParams.get("filterType");
    const filterValue = queryParams.get("filterValue");

    console.log("Applying filters from query params:", {
      filterType,
      filterValue,
    });

    if (filterType && filterValue) {
      // Update the state based on query parameters
      this.setState(
        {
          selectedParticipantType: filterValue, // Set selected type in state
        },
        () => {
          this.applyFilters(); // Apply filters after updating the state
        }
      );
    }
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  toggleMembershipModal = () => {
    this.setState(
      prevState => ({
        isMembershipModalOpen: !prevState.isMembershipModalOpen,
      }),
      () => {
        console.log(
          "Modal Toggled, New State:",
          this.state.isMembershipModalOpen
        );
      }
    );
  };
  togglePaymentModal = () => {
    this.setState(
      prevState => ({
        isPaymentModalOpen: !prevState.isPaymentModalOpen,
      }),
      () => {
        console.log("Modal Toggled, New State:", this.state.isPaymentModalOpen);
      }
    );
  };

  handleEditSubmit(values) {
    console.log("Form values:", values);

    const updatedData = {
      id: values.id,
      name: values.name,
      email: values.email,
      address: values.address,
      province: values.province, // ✅ Add this line
      lab_staff_designation: values.lab_staff_designation,
      shipping_address: values.shipping_address,
      billing_address: values.billing_address,
      marketer_name: values.marketer_name,
      city: values.city,
      district: values.district,
      lab_staff_name: values.lab_staff_name,
      // designation: values.designation,
      email_participant: values.email_participant,
      landline_registered_by: values.landline_registered_by,
      payment_status: values.payment_status,
      payment_settlement: values.payment_settlement,
    };

    this.props.onupdateAllLabs(updatedData); // Dispatch update action

    // Show success message
    this.setState({ successMessage: "Participant updated successfully" });

    // Delay modal close by 2 seconds
    setTimeout(() => {
      this.setState({ editModal: false, successMessage: "" });
    }, 2000);
  }

  componentDidMount() {
    console.log("Fetching data...");
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    console.log("Retrieved user_id:", user_id);

    // Set user_id in state
    this.setState({ user_id }, () => {
      // Get organization_name from URL params
      const { organization_name } = this.props.match.params || {};
      console.log("organization_name from props:", organization_name);

      if (organization_name) {
        this.setState({ organization_name }, () => {
          console.log("Organization name set:", this.state.organization_name);

          this.fetchData(this.state.user_id);
          this.applyFiltersFromQueryParams();
          // Fetch city options

          this.fetchData(user_id);
        });
      } else {
        console.error("Organization name is missing in URL parameters.");
      }
    });
  }
  handleSchemeSelect = e => {
    const selectedScheme = e.target.value;
    if (!selectedScheme) {
      this.setState({
        selectedScheme: null,
        showCycleFilter: false,
        selectedCycle: null,
      });
      return;
    }

    // Filter cycles that belong to the selected scheme
    const filteredCycleOptions = this.state.CycleList.filter(
      cycle => cycle.scheme_id?.toString() === selectedScheme.toString()
    );

    this.setState({
      selectedScheme,
      filteredCycleOptions,
      showCycleFilter: true,
      selectedCycle: null,
    });
  };

  handleCycleSelect = e => {
    const selectedCycle = e.target.value;
    this.setState({ selectedCycle }, () => {
      console.log("Selected Scheme:", this.state.selectedScheme);
      console.log("Selected Cycle:", this.state.selectedCycle);
      this.applyFilters();
    });
  };

  // New method to fetch cities

  // Fetch all required data
  fetchData(user_id) {
    const { ongetApprovedLabs, ongetcyclelist, onGetPendingLabs } = this.props;

    ongetApprovedLabs(user_id);
    console.log("ongetApprovedLabs called with user_id:", user_id);

    // Call cycle list API
    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);

    // Call pending labs API
    onGetPendingLabs(user_id);
    console.log("onGetPendingLabs called with user_id:", user_id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filteredLabs !== this.state.filteredLabs) {
      console.log("FilteredLabs updated:", this.state.filteredLabs);
    }
    if (prevProps.approvedLabs !== this.props.approvedLabs) {
      // Logic for approvedLabs if needed
    }
    if (prevProps.CycleList !== this.props.CycleList) {
      console.log("Updating CycleList in state:", this.props.CycleList);
      this.setState({ CycleList: this.props.CycleList });
    }
    if (prevProps.CSRList !== this.props.CSRList) {
      console.log("CSRList prop updated:", this.props.CSRList);
      console.log("CSRList length:", this.props.CSRList?.length);
    }
    if (prevProps.AllLabs !== this.props.AllLabs) {
      console.log("Updated AllLabs:", this.props.AllLabs);

      // Extract unique provinces from API
      const provinces = [
        ...new Set(
          (this.props.AllLabs || []).map(lab => lab.province).filter(Boolean)
        ),
      ];

      console.log("Extracted Provinces:", provinces);

      this.setState(
        {
          AllLabs: this.props.AllLabs,
          provinceOptions: provinces,
        },
        () => {
          this.applyFilters();
        }
      );
    }

    if (
      prevProps.AllLabs !== this.props.AllLabs ||
      prevProps.CycleList !== this.props.CycleList
    ) {
      console.log("Filtering CycleList for participants");

      // Extract unique scheme names from AllLabs
      const participantSchemes = new Set(
        this.props.AllLabs.flatMap(
          lab => lab.schemes?.map(scheme => scheme.scheme_name) || []
        )
      );

      // Generate the filtered list for participant dropdown
      const filteredCycleList = this.props.CycleList.filter(cycle =>
        participantSchemes.has(cycle.scheme_name)
      );

      this.setState({
        CycleList: this.props.CycleList,
        filteredCycleList,
      });
    }
  }

  openPatientModal = (e, arg) => {
    this.setState({
      PatientModal: true,
      email: arg.email,
      landline_registered_by: arg.landline_registered_by,
    });
  };

  toggleEditModal = (participant = null) => {
    this.setState(
      prev => ({
        editModal: !prev.editModal,
        selectedParticipant: participant || prev.selectedParticipant,
        showModal: participant ? true : !prev.showModal,
      }),
      () => {
        // If modal is now closed, refresh data
        if (!this.state.editModal) {
          this.fetchData(this.state.user_id);
        }
      }
    );
  };
  toggleLabModal = () => {
    this.setState(prevState => ({
      LabModal: !prevState.LabModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggleModal = () => {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };
  openLabModal = (e, arg) => {
    this.setState({
      LabModal: true,
      email: arg.email,
      name: arg.name,
      shipping_address: arg.shipping_address,
      lab_code: arg.lab_code,
      password_foradmins: arg.password_foradmins,
      billing_address: arg.billing_address,
    });
  };
  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  togglePatientModal = () => {
    this.setState(prevState => ({
      PatientModal: !prevState.PatientModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  openMarketerModal = (e, arg) => {
    this.setState({
      MarketerModal: true,
      marketer_name: arg.marketer_name,
      marketer_phone: arg.marketer_phone,
    });
  };
  toggleMarketerModal = () => {
    this.setState(prevState => ({
      MarketerModal: !prevState.MarketerModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleApprovedEvent = id => {
    this.setState({ id: id, isApproved: true, unapprovedModal: true });
  };

  handleUnapprovedEvent = id => {
    this.setState({ id: id, isApproved: false, unapprovedModal: true });
  };

  callOnApproveUnapproveLab = () => {
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;

    const data = {
      id: this.state.user_id,
      labId: this.state.id,
      isApproved: this.state.isApproved,
    };

    // calling to unapprove lab
    onApproveUnapproveLab(data);

    // Calling to update list record
    setTimeout(() => {
      onGetPendingLabs(this.state.user_id);
    }, 1000);

    this.setState({ unapprovedModal: false });
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  exportToExcel = () => {
    const { filteredLabs, selectedScheme } = this.state;

    if (!filteredLabs || filteredLabs.length === 0) {
      console.error("No data available to export.");
      alert("No data available to export.");
      return;
    }

    const selectedFields = [
      { key: "province", label: "Province" },
      { key: "district", label: "District" },
      { key: "city", label: "City" },
      { key: "name", label: "Name" },
      { key: "shipping_address", label: "Address Shipping" },
      { key: "billing_address", label: "Address Billing Address" },
      { key: "lab_code", label: "lab_code" },
      { key: "email", label: "Email" },
      { key: "email_participant", label: "Email of Notification Person" },
      { key: "password_foradmins", label: "password" },
      { key: "lab_staff_name", label: "Name of Notification Person" },
      { key: "lab_staff_designation", label: "Designation" },
      {
        key: "landline_registered_by",
        label: "Contact No of Notification Person",
      },
      { key: "schemes", label: "Schemes" },
      { key: "payment_status", label: "Payment Status" },
      { key: "payment_settlement", label: "Payment Settlement" },
      { key: "membership_status", label: "Membership Status" },
    ];

    const dataToExport = filteredLabs.map(item => {
      const row = {};
      selectedFields.forEach(({ key, label }) => {
        if (key === "schemes") {
          if (Array.isArray(item.schemes)) {
            const uniqueSchemeNames = [
              ...new Set(item.schemes.map(s => s.scheme_name)),
            ];
            row[label] = uniqueSchemeNames.join(", ");
          } else {
            row[label] = "N/A";
          }
        } else {
          row[label] = item[key] || "N/A";
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const colWidths = Object.keys(dataToExport[0]).map(key => {
      const maxLength = Math.max(
        key.length,
        ...dataToExport.map(row => (row[key] ? row[key].toString().length : 10))
      );
      return { wch: maxLength + 2 };
    });

    ws["!cols"] = colWidths;
    const wb = { Sheets: { Participants: ws }, SheetNames: ["Participants"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    // 🆕 Extract scheme_id and cycle_id from selectedScheme if available
    const [schemeId, cycleId] = (selectedScheme || "").split("-");
    const fileName = schemeId
      ? `Participants_Scheme_${schemeId}_Cycle_${cycleId}.xlsx`
      : "All_Participants.xlsx";

    saveAs(data, fileName);
  };

  getSchemeCounts = () => {
    const { filteredLabs } = this.state;

    const schemeCounts = {};

    filteredLabs.forEach(lab => {
      if (Array.isArray(lab.schemes)) {
        lab.schemes.forEach(scheme => {
          const name = scheme.scheme_name;
          schemeCounts[name] = (schemeCounts[name] || 0) + 1;
        });
      }
    });

    return schemeCounts;
  };

  refreshPage = () => {
    // call your API or reload data
    this.fetchData(this.state.user_id);
    this.applyFilters();
  };
  render() {
    console.log("Rendering table with data:", this.state.filteredLabs);
    const csrOptions = (this.props.CSRList || []).map(username => ({
      value: username,
      label: username,
    }));
    const schemeCounts = this.getSchemeCounts();
    // ── Inject participant count into the "Participant" column header ──
    const filteredCount = this.state.filteredLabs.length;
    const columnsWithCount = this.state.pendingLabListColumns.map(col => {
      if (col.dataField === "name") {
        return {
          ...col,
          text: (
            <div>
              <div>Participant</div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#000000",
                  marginTop: "2px",
                  letterSpacing: "0.3px",
                }}
              >
                Total: {filteredCount}
              </div>
            </div>
          ),
        };
      }
      return col;
    });
    const { AllLabs } = this.props;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: AllLabs.length, // replace later with size(AllLabs),
      custom: true,
    };
    const maxSchemeCount = this.getMaxSchemeCount();
    const schemeCountOptions = Array.from(
      { length: maxSchemeCount },
      (_, i) => i + 1
    );

    // const { isPaymentModalOpen } = this.state;
    const { approvedLabs, CycleList } = this.state;

    const schemeOptions = CycleList.filter(
      scheme => scheme.status && scheme.status.toLowerCase() === "active"
    ).map(scheme => ({
      value: `${scheme.scheme_id}-${scheme.id}`,
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
      scheme_id: scheme.scheme_id,
      cycle_id: scheme.id,
    }));

    console.log("Mapped scheme option:", schemeOptions);
    const { isModalOpen, toggleModal, isOpen, toggle, onSubmit } = this.state;
    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];
    const customStyles = {
      // <-- This is invalid here
      control: provided => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Pending Labs | External QC</title>
          </MetaTags>

          <ApproveUnapproveModal
            show={this.state.unapprovedModal}
            onYesClick={this.callOnApproveUnapproveLab}
            onCloseClick={() => this.setState({ unapprovedModal: false })}
          />

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Lists of Participants" />
            <p
              style={{
                color: "black",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Note: Only active cycles of schemes are displayed here.
            </p>
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <Row className="justify-content-end">
                      <Col lg="auto" className="text-end">
                        <Button
                          onClick={this.exportToExcel}
                          className="mb-3"
                          disabled={
                            !this.state.AllLabs ||
                            this.state.AllLabs.length === 0
                          }
                        >
                          Export to Excel
                        </Button>
                      </Col>
                    </Row>

                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columnsWithCount}
                      data={this.state.filteredLabs}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columnsWithCount}
                          data={this.state.filteredLabs}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-3">
                                <Col sm="12">
                                  <div className="d-flex flex-wrap gap-2 align-items-center">
                                    {/* 1. Participant Type */}
                                    <select
                                      className="form-select"
                                      style={{ width: "180px" }}
                                      onChange={
                                        this.handleParticipantTypeChange
                                      }
                                      value={this.state.selectedParticipantType}
                                    >
                                      <option value="All Participant">
                                        All Participant
                                      </option>
                                      <option value="Approved Participant">
                                        Approved Participant
                                      </option>
                                      <option value="Unapproved Participant">
                                        Unapproved Participant
                                      </option>
                                      <option value="Pending Participant">
                                        Pending Participant
                                      </option>
                                      <option value="Suspended Participant">
                                        Suspended Participant
                                      </option>
                                      <option value="New Register">
                                        New Register
                                      </option>
                                    </select>

                                    {/* 2. Province */}
                                    <select
                                      className="form-select"
                                      style={{ width: "160px" }}
                                      value={this.state.selectedProvince}
                                      onChange={e =>
                                        this.setState(
                                          { selectedProvince: e.target.value },
                                          this.applyFilters
                                        )
                                      }
                                    >
                                      <option value="">All Provinces</option>
                                      {this.state.provinceOptions.map(
                                        (prov, i) => (
                                          <option key={i} value={prov}>
                                            {prov}
                                          </option>
                                        )
                                      )}
                                    </select>

                                    {/* 3. Scheme */}
                                    <select
                                      className="form-select"
                                      style={{ width: "200px" }}
                                      value={this.state.selectedScheme || ""}
                                      onChange={e => this.handleSchemeSelect(e)}
                                    >
                                      <option value="">All Schemes</option>
                                      {Array.isArray(
                                        this.state.filteredCycleList
                                      ) &&
                                        [
                                          ...new Map(
                                            this.state.filteredCycleList.map(
                                              item => [
                                                String(item.scheme_id),
                                                item,
                                              ]
                                            )
                                          ).values(),
                                        ].map(scheme => (
                                          <option
                                            key={scheme.scheme_id}
                                            value={String(scheme.scheme_id)}
                                          >
                                            {scheme.scheme_name}
                                          </option>
                                        ))}
                                    </select>

                                    {/* 4. Cycle (only when scheme selected) */}
                                    {this.state.showCycleFilter && (
                                      <select
                                        className="form-select"
                                        style={{ width: "160px" }}
                                        value={this.state.selectedCycle || ""}
                                        onChange={e =>
                                          this.handleCycleSelect(e)
                                        }
                                      >
                                        <option value="">All Cycles</option>
                                        {this.state.filteredCycleOptions.map(
                                          cycle => (
                                            <option
                                              key={cycle.id}
                                              value={cycle.id}
                                            >
                                              Cycle {cycle.cycle_no}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    )}

                                    {/* 5. Scheme Count */}
                                    <select
                                      className="form-select"
                                      style={{ width: "160px" }}
                                      value={this.state.selectedSchemeCount}
                                      onChange={this.handleSchemeCountChange}
                                    >
                                      <option value="">Scheme Count</option>
                                      {Array.from(
                                        { length: this.getMaxSchemeCount() },
                                        (_, i) => i + 1
                                      ).map(count => (
                                        <option key={count} value={count}>
                                          {count}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2 mt-3">
                                {/* <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col> */}
                              </Row>
                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={`table-${this.state.filteredLabs.length}`} // Unique key for each data update
                                      keyField="id"
                                      data={this.state.filteredLabs}
                                      columns={columnsWithCount}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed  "
                                      }
                                      bordered={false}
                                      striped={false}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                      rowClasses={(row, rowIndex) =>
                                        rowIndex % 2 === 0 ? "row-a" : "row-b"
                                      }
                                    />
                                    <Modal
                                      isOpen={this.state.LabModal}
                                      className={this.props.className}
                                      onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleLabModal}
                                        tag="h4"
                                      >
                                        <strong>
                                          {this.state.name || "Lab Details"}
                                        </strong>
                                      </ModalHeader>

                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      UserName
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.email}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Lab Code
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.lab_code
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Password
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .password_foradmins
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Shipping Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .shipping_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Billing Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .billing_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.MarketerModal}
                                      className={this.props.className}
                                      onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleMarketerModal}
                                        tag="h4"
                                      >
                                        <span></span>
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Name
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.marketer_name
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      City
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.city}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      District
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.district
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.PatientModal}
                                      className={this.props.className}
                                      onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.togglePatientModal}
                                        tag="h4"
                                      >
                                        <span></span>
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Email
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.email}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Mobile No.
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-6">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .landline_registered_by
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                  {/* /////////////////// */}
                                                  <div className="col-md-6">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .payment_status
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                  <div className="col-md-3">
                                                    <button
                                                      type="button"
                                                      className="btn btn-secondary"
                                                      onClick={() => {
                                                        navigator.clipboard.writeText(
                                                          this.state
                                                            .payment_status
                                                        );
                                                        this.setState({
                                                          btnText: "Copied",
                                                        });
                                                      }}
                                                    >
                                                      {this.state.btnText}
                                                    </button>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>

                                    <Modal
                                      isOpen={this.state.isMembershipModalOpen}
                                      toggle={this.toggleMembershipModal}
                                      className={this.props.className}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleMembershipModal}
                                      >
                                        Updating Membership for{" "}
                                        {this.state.selectedParticipant?.name ||
                                          "Unknown"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            membership: "", // Default empty value
                                            participant:
                                              this.state.selectedParticipant
                                                ?.id || "",
                                            // Participant ID passed as prop
                                            added_by: localStorage.getItem(
                                              "authUser"
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser"
                                                  )
                                                ).user_id
                                              : "",
                                          }}
                                          validationSchema={Yup.object().shape({
                                            membership:
                                              Yup.string().required(
                                                "Status required"
                                              ),
                                          })}
                                          onSubmit={async (
                                            values,
                                            { setSubmitting, resetForm }
                                          ) => {
                                            console.log(
                                              "Form Values Submitted:",
                                              values
                                            );
                                            console.log(
                                              "Form Values Submitted:",
                                              values
                                            );
                                            console.log(
                                              "Participant ID:",
                                              values.participant
                                            );

                                            if (!values.participant) {
                                              console.error(
                                                "Error: Lab ID (participant) is missing!"
                                              );
                                              return;
                                            }

                                            const userId = localStorage.getItem(
                                              "authUser"
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser"
                                                  )
                                                ).user_id
                                              : "";

                                            const UpdateMembership = {
                                              membership_status:
                                                values.membership, // Correct key
                                              added_by: userId, // This should match the logged-in user's ID
                                              participant: values.participant, // Participant ID should come here
                                            };
                                            console.log(
                                              "Selected Participant ID:",
                                              this.state.selectedParticipant?.id
                                            );

                                            console.log(
                                              "Payload being sent to API:",
                                              UpdateMembership
                                            );

                                            try {
                                              await this.props.onupdateMembershipStatus(
                                                this.state.user_id,
                                                UpdateMembership
                                              );
                                              this.props.ongetApprovedLabs(
                                                this.state.user_id
                                              );
                                              this.props.onupdateMembershipStatus(
                                                this.state.user_id
                                              );
                                              await this.props.onGetPendingLabs(
                                                this.state.user_id
                                              ); //membership modal
                                              this.setState({
                                                isMembershipModalOpen: false,
                                              }); // Close modal here
                                              resetForm();
                                              this.displaySuccessMessage(
                                                "Membership status updated successfully!"
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Error updating membership status:",
                                                error
                                              );
                                            }
                                            this.setState({
                                              isMembershipModalOpen: false,
                                            });
                                            setSubmitting(false);
                                          }}
                                        >
                                          {({
                                            values,
                                            errors,
                                            touched,
                                            setFieldValue,
                                          }) => {
                                            const membershipOptions = [
                                              {
                                                value: "Active",
                                                label: "Active",
                                              },
                                              {
                                                value: "Inactive",
                                                label: "Inactive",
                                              },
                                              {
                                                value: "Suspended",
                                                label: "Suspended",
                                              },
                                            ];

                                            return (
                                              <Form>
                                                <Row>
                                                  <Col>
                                                    <Label>
                                                      Membership Status
                                                    </Label>
                                                    <Select
                                                      name="membership"
                                                      options={
                                                        membershipOptions
                                                      }
                                                      placeholder="Select Status"
                                                      className={
                                                        errors.participant &&
                                                        touched.participant
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                      onChange={selectedOption => {
                                                        setFieldValue(
                                                          "membership",
                                                          selectedOption?.value ||
                                                            ""
                                                        );
                                                      }}
                                                      value={
                                                        membershipOptions.find(
                                                          option =>
                                                            option.value ===
                                                            values.membership
                                                        ) || null
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="membership"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>
                                                </Row>

                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    type="submit"
                                                  >
                                                    Save
                                                  </Button>
                                                </ModalFooter>
                                              </Form>
                                            );
                                          }}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>

                                    <Modal
                                      isOpen={this.state.isMembershipModalOpen}
                                      toggle={this.toggleMembershipModal}
                                      className={this.props.className}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleMembershipModal}
                                      >
                                        Updating Membership for{" "}
                                        {this.state.selectedParticipant?.name ||
                                          "Unknown"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            membership: "", // Default empty value
                                            participant:
                                              this.state.selectedParticipant
                                                ?.id || "",
                                            // Participant ID passed as prop
                                            added_by: localStorage.getItem(
                                              "authUser"
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser"
                                                  )
                                                ).user_id
                                              : "",
                                          }}
                                          validationSchema={Yup.object().shape({
                                            membership:
                                              Yup.string().required(
                                                "Status required"
                                              ),
                                          })}
                                          onSubmit={async (
                                            values,
                                            { setSubmitting, resetForm }
                                          ) => {
                                            console.log(
                                              "Form Values Submitted:",
                                              values
                                            );
                                            console.log(
                                              "Form Values Submitted:",
                                              values
                                            );
                                            console.log(
                                              "Participant ID:",
                                              values.participant
                                            );

                                            if (!values.participant) {
                                              console.error(
                                                "Error: Lab ID (participant) is missing!"
                                              );
                                              return;
                                            }

                                            const userId = localStorage.getItem(
                                              "authUser"
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser"
                                                  )
                                                ).user_id
                                              : "";

                                            const UpdateMembership = {
                                              membership_status:
                                                values.membership, // Correct key
                                              added_by: userId, // This should match the logged-in user's ID
                                              participant: values.participant, // Participant ID should come here
                                            };
                                            console.log(
                                              "Selected Participant ID:",
                                              this.state.selectedParticipant?.id
                                            );

                                            console.log(
                                              "Payload being sent to API:",
                                              UpdateMembership
                                            );

                                            try {
                                              await this.props.onupdateMembershipStatus(
                                                this.state.user_id,
                                                UpdateMembership
                                              );
                                              this.props.ongetApprovedLabs(
                                                this.state.user_id
                                              );
                                              this.props.onupdateMembershipStatus(
                                                this.state.user_id
                                              );
                                              await this.props.onGetPendingLabs(
                                                this.state.user_id
                                              ); //membership modal
                                              this.setState({
                                                isMembershipModalOpen: false,
                                              }); // Close modal here
                                              resetForm();
                                              this.displaySuccessMessage(
                                                "Membership status updated successfully!"
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Error updating membership status:",
                                                error
                                              );
                                            }
                                            this.setState({
                                              isMembershipModalOpen: false,
                                            });
                                            setSubmitting(false);
                                          }}
                                        >
                                          {({
                                            values,
                                            errors,
                                            touched,
                                            setFieldValue,
                                          }) => {
                                            const membershipOptions = [
                                              {
                                                value: "Active",
                                                label: "Active",
                                              },
                                              {
                                                value: "Inactive",
                                                label: "Inactive",
                                              },
                                              {
                                                value: "Suspended",
                                                label: "Suspended",
                                              },
                                            ];

                                            return (
                                              <Form>
                                                <Row>
                                                  <Col>
                                                    <Label>
                                                      Membership Status
                                                    </Label>
                                                    <Select
                                                      name="membership"
                                                      options={
                                                        membershipOptions
                                                      }
                                                      placeholder="Select Status"
                                                      className={
                                                        errors.participant &&
                                                        touched.participant
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                      onChange={selectedOption => {
                                                        setFieldValue(
                                                          "membership",
                                                          selectedOption?.value ||
                                                            ""
                                                        );
                                                      }}
                                                      value={
                                                        membershipOptions.find(
                                                          option =>
                                                            option.value ===
                                                            values.membership
                                                        ) || null
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="membership"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>
                                                </Row>

                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    type="submit"
                                                  >
                                                    Save
                                                  </Button>
                                                </ModalFooter>
                                              </Form>
                                            );
                                          }}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.showSchemeModal}
                                      toggle={this.handleSchemeModalClose}
                                    >
                                      <ModalHeader
                                        toggle={this.handleSchemeModalClose}
                                      >
                                        {this.state.selectedParticipant?.name ||
                                          "Participant"}{" "}
                                        — Purchased Schemes
                                      </ModalHeader>
                                      <ModalBody>
                                        {this.state.selectedSchemes &&
                                        this.state.selectedSchemes.length >
                                          0 ? (
                                          <ul style={{ paddingLeft: "15px" }}>
                                            {this.state.selectedSchemes.map(
                                              (scheme, i) => (
                                                <li key={i}>
                                                  {scheme.scheme_name}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        ) : (
                                          <p>No schemes found.</p>
                                        )}
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          {this.state.showPaymentModal && (
            <AllParticipantPaymentModal
              isOpen={this.state.showPaymentModal}
              toggle={() => {
                this.setState({
                  showPaymentModal: false,
                });
                this.fetchData(this.state.user_id);
              }}
              selectedParticipant={this.state.selectedParticipant}
              onSuccess={() => {
                this.refreshPage();
              }}
            />
          )}
          {this.state.showModal &&
            this.state.editModal &&
            this.state.selectedParticipant && (
              <AllParticipantsEditparticipantsModal
                isOpen={this.state.editModal}
                toggle={() => {
                  this.setState({
                    editModal: false,
                    showModal: false,
                    selectedParticipant: null,
                  });
                  this.fetchData(this.state.user_id);
                }}
                participant={this.state.selectedParticipant}
                onSuccess={() => {
                  this.refreshPage();
                }}
              />
            )}
        </div>
      </React.Fragment>
    );
  }
}

PendingLabs.propTypes = {
  match: PropTypes.object,
  AllLabs: PropTypes.array,
  className: PropTypes.any,
  onGetPendingLabs: PropTypes.func,
  onApproveUnapproveLab: PropTypes.func,
  history: PropTypes.any,
  onupdateAllLabs: PropTypes.any,
  onAddNewPayment: PropTypes.func,
  onupdateMembershipStatus: PropTypes.func,
  participantId: PropTypes.func,
  ongetApprovedLabs: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  approvedLabs: PropTypes.array,
  CSRList: PropTypes.array,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,

  CycleList: PropTypes.array,
  isPaymentModalOpen: PropTypes.array,
  togglePaymentModal: PropTypes.array,
  isMembershipModalOpen: PropTypes.array,
  toggleMembershipModal: PropTypes.array,
};
const mapStateToProps = ({
  Account,
  AddPayment,
  registrationAdmin,
  CycleList,
}) => {
  console.log("registrationAdmin:", registrationAdmin);
  console.log("CycleList from props:", CycleList);
  console.log("csr_staff from state:", AddPayment?.csr_staff);
  return {
    userID: Account?.userID || null,

    AllLabs: registrationAdmin?.AllLabs || [],
    approvedLabs: registrationAdmin?.approvedLabs || [],
    CSRList: AddPayment?.csr_staff || [], // ← renamed
    CycleList: CycleList?.CycleList || [],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onApproveUnapproveLab: data => dispatch(approveUnapproveLab(data)),
  onGetPendingLabs: id => dispatch(getAllLabs(id)),
  onGetInstrumentTypeList: id => dispatch(getSchemelist(id)),
  onAddNewType: (id, createUnit) => dispatch(addNewSchemeList(id, createUnit)),
  onUpdateType: (id, methodlist) =>
    dispatch(updateSchemeList({ id, ...methodlist })),
  onupdateAllLabs: updatedData => {
    console.log("Dispatching updatedData:", updatedData); // Check if updated data is being passed
    dispatch(updateAllLabs(updatedData));
  },

  ongetApprovedLabs: id => dispatch(getApprovedLabs(id)),
  ongetcyclelist: id => dispatch(getcyclelist(id)),
  onAddNewPayment: (id, payment) => dispatch(addNewPayment(id, payment)),
  onupdateMembershipStatus: (id, status) => {
    console.log("Updating Membership Status - ID:", id, "Status:", status);
    dispatch(updateMembershipStatus({ id, ...status }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PendingLabs));
